<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-tableLoading="tableLoading" :page="page"
                ref="crud" @row-save="handleSave" @row-update="handleSave" @search-change="searchChange"
                @refresh-change="refreshChange(page)" @selection-change="handleSelectionChange"
                @size-change="pageSizeChange" @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary" size="small" plain @click.stop="handleAdd(scope.row, scope.index)">
                        <i class="el-icon-plus"></i>新增
                    </el-button>
                    <el-button type="danger" size="small" plain @click.stop="handleDel()">
                        <i class="el-icon-delete"></i>删除
                    </el-button>
                </template>
            </avue-crud>
        </basic-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { reminderOption } from "@/const/work/waterProject/reminderOption";
import { findReminder, addReminder, updateReminder, delReminder } from "@/api/work/waterProject/reminder";
export default {
    name: "reminderForm",
    data() {
        return {
            tableOption: reminderOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            superiorIds: [],
            superiorId: {},
            serviceCategoryName: {},
            categoryTypes: [],
            classifySelects: [],
            currClassify: [],
            tabelObj: {},
            ids: "",
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10, //每页显示多少条
            },
            grade: {
                box: false,
                check: [],
            },
        };
    },
    created() {
        this.handleList();
    },
    watch: {},
    mounted() { },
    computed: {
        ...mapGetters(["permission"]),
    },
    props: [],
    methods: {
        filterEmptyParams(obj) {
            const result = {};
            if (!obj) return result;
            for (const key in obj) {
                const val = obj[key];
                if (val !== null && val !== undefined && val !== "" && !(Array.isArray(val) && val.length === 0)) {
                    result[key] = val;
                }
            }
            return result;
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.filterEmptyParams(this.$refs.crud.searchForm);
            params.page = this.page.currentPage;
            params.size = pageSize;
            params.type = "PURE_WATER";

            this.downloadData = params;
            findReminder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize,
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.filterEmptyParams(this.$refs.crud.searchForm);
            params.page = page;
            params.size = this.page.pageSize;
            params.type = "PURE_WATER";

            this.downloadData = params;
            findReminder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            let filterParams = this.filterEmptyParams(params);
            filterParams.page = this.page.currentPage;
            filterParams.size = this.page.pageSize;
            filterParams.type = "PURE_WATER";

            findReminder(filterParams).then((res) => {
                if (res.code != 500) {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: filterParams.page,
                        pageSize: filterParams.size,
                    };
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.tableData = [];
                }
            });
        },
        //eslint-disable-next-line
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.filterEmptyParams(this.$refs.crud.searchForm);
            params.page = page.currentPage;
            params.size = page.pageSize;
            params.type = "PURE_WATER";
            this.downloadData = params;

            findReminder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        /**
         * @title 打开新增窗口
         * @detail 调用crud的handleadd方法即可
         *
         **/
        handleAdd() {
            this.$refs.crud.rowAdd();
        },
        handleSave(row, addDone, done) {
            if (row.id) {
                console.log(row);
                updateReminder(row, done)
                    .then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "修改成功",
                                type: "success",
                            });
                            console.log(response, "response1");
                            this.handleList();
                        } else {
                            console.log(response, "response2");
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        this.tableLoading = false;
                        this.$message({
                            showClose: true,
                            message: error,
                            type: "error",
                        });
                    });
                done();
            } else {
                const parmas = {
                    phone: row.phone,
                    flag: row.flag,
                    type: "PURE_WATER"
                };
                addReminder(parmas)
                    .then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "新增成功",
                                type: "success",
                            });
                            this.handleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        this.tableLoading = false;
                        this.$message({
                            showClose: true,
                            message: error,
                            type: "error",
                        });
                    });
                addDone();
            }
        },
        handleEdit() {
            this.$refs.crud.rowEdit();
        },
        handleView() {
            this.$refs.crud.rowView();
        },

        /**
         * @title 获取数据
         * @detail 赋值为tableData表格即可
         *
         **/
        handleList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize,
                type: "PURE_WATER"
            };
            this.downloadData = params;
            findReminder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange(val) {
            let ids = val.map((item) => {
                return item.id;
            });
            this.ids = ids.join(",");
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel() {
            if (this.$refs.crud.tableSelect.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择要操作的数据",
                    type: "error",
                });
                return;
            }

            this.$confirm(`是否确认删除?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let ids = new Array();
                    for (let row of this.$refs.crud.tableSelect) {
                        ids.push(row.id);
                    }

                    delReminder(ids)
                        .then((response) => {
                            if (response.code == "200") {
                                this.$message({
                                    showClose: true,
                                    message: "删除成功",
                                    type: "success",
                                });
                                this.handleList();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.message,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {
                            this.tableLoading = false;
                            this.$message({
                                showClose: true,
                                message: error,
                                type: "error",
                            });
                        });
                })
                .catch(() => { });
        },
    },
};
</script>

<style lang="scss">
.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
</style>